import { useTranslation } from "react-i18next";
import { useOfferPerformance } from "src/data/admin/queries/analytics";
import { DateRangeParams } from "src/data/admin/types/analytics";
import { OfferPerformanceTable } from "./OfferPerformanceTable";

export const EventPerformanceSection = ({ range }: { range: DateRangeParams }) => {
  const { t } = useTranslation();

  const { data } = useOfferPerformance(range);
  const events = data?.events;

  if (!events || events.rows.length === 0) return null;

  return (
    <OfferPerformanceTable
      title={t("analytics.offerPerformance.eventsTitle")}
      rows={events.rows}
      totals={events.totals}
    />
  );
};
